<template>
  <div id="digital-detail-application">
    <b-container v-if="hasNoAccess">
      <b-alert variant="warning" show class="my-0">
        Sie haben keinen Zugriff
      </b-alert>
    </b-container>
    <b-overlay :show="showOverlay" rounded="sm" v-else>
      <b-alert v-model="hasUnknownError" variant="danger">
        {{ $t('formError.unknownwError') }}
      </b-alert>
      <b-alert v-model="hasError" variant="danger">
        {{ errorMessage }}
      </b-alert>
      <b-container class="modal-custom-title last-custom-title">
        <div class="mb-4">
          <b-button to="/uebersicht">Zurück</b-button>
        </div>
        <b-row>
          <b-col lg="12">
            <div class="text-wrapper">
              <h1>
                <strong>Gesuch</strong>
                <span> | {{application.gesuchKey}} </span>
              </h1>
              <h1 class="red-title">{{application.gesuchArtAbkuerzung}}</h1>
              <sign-button-download
                v-if="[12, 16].includes(this.application.statusId)"
                :applicationId="Number(this.$route.params.applicationId)"
                :showSpinner="true"
                buttonArt="digitaldetail"
                :gesuchArt="application.gesuchArt"
              />
            </div>
          </b-col>
        </b-row>
      </b-container>
      <b-container>
        <div class="row mt-2">
          <div class="col-lg-12">
            <b-tabs class="application-tabs" v-model="selectedTab">
              <b-tab :title="dynamicTabName" active>
                <div class="row">
                  <div class="col-lg-7" v-if="![13,14,7].includes(application.statusId)">
                    <div class="pt-2 files-list" v-if="historyFiles">
                      <h4 v-if="countItems() > 5" @click="handleHistory" class="red-h4 mt-0 mb-2 cursor"><strong>Bereits hochgeladene Dokumente ({{countItems()}})</strong> <b-icon icon="caret-down-fill" :rotate="historyIconRotate" class="icon-history"></b-icon></h4>
                      <h4 v-else class="red-h4 mt-0 mb-2"><strong>Bereits hochgeladene Dokumente</strong></h4>
                      <div v-for="file in fileHistory" :key="file.fileId" v-show="(showHistory && countItems() > 5) || countItems() <= 5">
                        <p class="mb-3" v-if="!file.deleteAllowed"><file-icon class="icon-gray" :size="18"/><strong> {{ file.fileName.slice(15).replace(/(.{50})..+/, "$1&hellip;") }} </strong></p>
                      </div>
                    </div>
                    <h4 class="red-h4 mb-1"><strong>Beilagen hochladen</strong></h4>
                    <p>Maximal 10MB pro Datei (PDF oder Bildformate) und verwenden Sie keine Sonderzeichen im Dateinamen. Pro Einsendung sind maximal {{ maxFileLimit }} Dateien erlaubt und 100MB im Gesamten.</p>
                    <p v-if="countCloudinaryFiles > maxFileLimit"><strong>Sie haben die Limite von {{maxFileLimit}} Dateien überschritten.</strong><br>Aktuell haben Sie <strong>{{countCloudinaryFiles}}</strong> Dateien hochgeladen.<br>
                      Bitte entfernen Sie einige Dateien, um Einreichen zu können.</p>
                    <b-alert v-model="wrongFormat" variant="danger" class="mt-2">
                      Falsches Format, nur PDF und Bildformate (PNG, JPG, ...) erlaubt.
                    </b-alert>
                    <b-alert v-model="longName" variant="danger" class="mt-2">
                      Der Dateiname ist zu lange, bitte maximal 60 Zeichen.
                    </b-alert>
                    <b-alert v-model="uploadProblem" variant="danger" class="mt-2">
                      Datei konnte nicht hochgeladen werden. Möglicherweise zu Gross, ungültiger Dateiname (Sonderzeichen) oder Format.
                    </b-alert>
                    <b-alert v-model="deleteProblem" variant="danger" class="mt-2">
                      Die Datei konnte nicht gelöscht werden. Bitte melden Sie sich bei der Energieagentur St. Gallen.
                    </b-alert>
                    <div class="pt-2 files-list" v-if="deleteFiles">
                      <div v-for="file in fileHistory" :key="file.fileId">
                        <p class="mb-3" v-if="file.deleteAllowed">
                          <file-icon class="icon-gray" :size="18"/>
                          <strong> {{ file.fileName.slice(15).replace(/(.{50})..+/, "$1&hellip;") }} </strong>
                          <a :href="getCloudinaryURL(file.fileId)" target="_blank"><download-icon class="ml-2" :size="22"/></a>
                          <close-icon @click="deleteFileModal(file.fileName)" title="File löschen" :size="22" class="remove-document"/>
                        </p>
                      </div>
                    </div>
                    <b-overlay
                      id="overlay-background"
                      :show="showUploadOverlay"
                      variant="light"
                      opacity="0.80"
                      rounded="sm"
                    >
                      <div class="dragdrop mb-2" v-cloak @drop.prevent="addFile" @dragover.prevent>
                        <input type="file" accept="image/*,.pdf" ref="file" style="display: none" @change="onFileChange">
                        <a class="icon-lg rounded-circle" @click="$refs.file.click()">
                          <span class="icon-add"></span>
                        </a>
                        <p class="drag-drop-text"><strong>Dokumente per Drag and Drop hineinziehen</strong></p>
                      </div>
                    </b-overlay>
                    <a v-b-modal.modal-help-digital-application><help-icon fillColor="#DC1E50"/></a>
                    <help-modal/>
                    <div v-if="application.statusId === 12 || application.statusId === 16">
                      <b-row class="mt-4" v-if="!currentUserOwner && !compareOwnerWithInvitation">
                        <b-col md="6">
                          <p class="mb-1">Sie haben eine Vollmacht:</p>
                          <b-button class="btn btn-green fullwidth" :disabled="uploadDisabled" @mousedown="openSignationModal">Gesuch signieren und einreichen</b-button>
                        </b-col>
                        <b-col md="6">
                          <p class="mb-1">Lassen Sie den Eigentümer signieren:</p>
                          <b-button class="btn btn-green fullwidth" :disabled="uploadDisabled" @mousedown="openOwnersModal">An den Eigentümer weiterleiten</b-button>
                        </b-col>
                      </b-row>
                      <b-row class="mt-4" v-else>
                        <b-col md="6">
                          <b-button class="btn btn-green fullwidth" :disabled="uploadDisabled" @mousedown="openSignationModal">Gesuch signieren und einreichen</b-button>
                        </b-col>
                      </b-row>
                    </div>
                    <div v-else-if="application.statusId === 3 && !application.projektabschlussAuswahl && !application.eingangAusfuehrungBestaetigungDatum">
                      <b-row class="mt-4">
                        <b-col md="6">
                          <b-button class="btn btn-green fullwidth" :disabled="hasError || (countCloudinaryFiles > maxFileLimit)" @mousedown="openProjektabschlussModal">Projektabschluss einreichen</b-button>
                        </b-col>
                      </b-row>
                    </div>
                    <div v-else-if="![12, 16].includes(application.statusId)">
                      <b-row class="mt-4">
                        <b-col md="6">
                          <p class="mb-1">Wollen Sie weitere Beilagen einsenden?<br>Laden Sie weitere Beilagen hoch und klicken Sie dann auf Abschicken.</p>
                          <b-button class="btn btn-green fullwidth" disabled v-if="isSubmitting">
                            <b-spinner small></b-spinner>
                            Abschicken
                          </b-button>
                          <b-button class="btn btn-green fullwidth" :disabled="uploadDisabled || hasError" @mousedown="sendFilesToServer" v-else>Abschicken</b-button>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                  <div class="col-lg-5">
                    <digital-application-state
                      class="status-badge"
                      :applicationData="application"
                      :selectedTab="selectedTab"
                    />
                  </div>
                </div>
              </b-tab>
              <b-tab title="Gesuchsdetails">
                <b-container class="detail-user">
                  <b-row>
                    <b-col md="4">
                      <h2>Gesuchssteller</h2>
                      <h5><strong>{{application.eigentuemer.vorname}} {{application.eigentuemer.name}}</strong></h5>
                      <p>
                        {{application.eigentuemer.strasse}} {{application.eigentuemer.hausNr}}<br>
                        {{application.eigentuemer.plz}} {{application.eigentuemer.ort}}
                      </p>
                      <p>
                        Tel-Nr: {{application.eigentuemer.telefon}}<br>
                        E-Mail: {{application.eigentuemer.email}}
                      </p>
                    </b-col>
                    <b-col md="4">
                      <h2>Kontaktperson</h2>
                      <h5><strong>{{application.kontaktPerson.vorname}} {{application.kontaktPerson.name}}</strong></h5>
                      <p>
                        {{application.kontaktPerson.strasse}} {{application.kontaktPerson.hausNr}}<br>
                        {{application.kontaktPerson.plz}} {{application.kontaktPerson.ort}}</p>
                      <p>
                        Tel-Nr: {{application.kontaktPerson.telefon}}<br>
                        E-Mail: {{application.kontaktPerson.email}}
                      </p>
                    </b-col>
                  </b-row>
                </b-container>
                <b-container class="detail-building">
                  <b-row>
                    <b-col md="12" v-if="Object.keys(application.objekt).length">
                      <h2>Gebäude</h2>
                      <table class="detail-table">
                        <tr v-for="item in application.objekt" v-bind:key="item.name">
                          <td>{{item.name}}:</td>
                          <td>{{item.value}}</td>
                        </tr>
                      </table>
                    </b-col>
                    <b-col md="12">
                      <h2>Detaildaten zum Gesuch</h2>
                      <table class="detail-table">
                        <tr v-for="( item, index ) in application.gesuch" :key="index">
                          <td>{{item.name}}:</td>
                          <td>{{item.value}}</td>
                        </tr>
                      </table>
                    </b-col>
                    <b-col md="12" v-if="application.zusicherung !== null">
                      <h2>Zusatzinfos</h2>
                      <table class="detail-table">
                        <tr>
                          <td>Fristablauf: </td>
                          <td>{{application.zusicherung.firstAblauf | moment("DD.MM.YYYY")}}</td>
                        </tr>
                        <tr v-if="application.zusicherung.betragKanton > 0">
                          <td>Förderbeitrag Kanton:</td>
                          <td>CHF {{application.zusicherung.betragKanton | formatCurrency}}</td>
                        </tr>
                        <tr v-if="application.zusicherung.betragGemeinde > 0">
                          <td>Förderbeitrag Gemeinde:</td>
                          <td>CHF {{application.zusicherung.betragGemeinde | formatCurrency}}</td>
                        </tr>
                      </table>
                    </b-col>
                  </b-row>
                </b-container>
              </b-tab>
              <b-tab title="Auf dem Postweg">
                <div class="row">
                  <div class="col-lg-7">
                    <h4 class="red-h4 mb-1"><strong>Adresse</strong></h4>
                    <p>Senden Sie die Beilagen an folgende Adresse:</p>
                    <p>Energieagentur St.Gallen GmbH<br>
                      Kornhausstrasse 25<br>
                      9000 St.Gallen</p>
                    <sign-button-download
                      :applicationId="Number(this.$route.params.applicationId)"
                      :showSpinner="false"
                      buttonArt="detail"
                      class="mb-4"
                    />
                    <p>Ihr Gesuch gilt erst dann als eingereicht, wenn die notwendigen Beilagen vollständig sind.
                      Drucken Sie das Gesuch aus, unterschreiben Sie es und fügen alle Beilagen bei.
                    </p>
                    <p>Wir prüfen die eingereichten Unterlagen und melden uns, falls etwas fehlt oder nicht korrekt ist.</p>
                  </div>
                  <div class="col-lg-5">
                    <digital-application-state
                      class="status-badge"
                      :applicationData="application"
                      :selectedTab="selectedTab"
                    />
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
        <owners-modal ref="ownersModal" :owners-mail="application.eigentuemer.email" :gesuchId="application.gesuchId" @refresh-application-redirected="refreshApplication"/>
        <signation-modal ref="signationModal" :gesuchId="application.gesuchId" :gesuchKey="application.gesuchKey" @refresh-application="refreshApplication"/>
        <delete-file-modal ref="deleteFilesModal"/>
        <projektabschluss-modal ref="projektabschlussModal" :uploadDisabled="uploadDisabled" :eingangZusicherung="application.eingangZusicherung" :gesuchId="application.gesuchId" :gesuchKey="application.gesuchKey" @refresh-projektabschluss-application="refreshApplication"/>
      </b-container>
    </b-overlay>
    <dx-toast
      :visible="showNotification"
      :message="notificationMessage"
      type="success"
      :displayTime="5000"
      :width="450"
      class="application-toast"
      @hidden="onHideNotification"
    >
      <dx-position
        my="right"
        at="right top"
        offset="-50 180"
      />
    </dx-toast>
    <div @click="topFunction" id="topBtn" v-show="showTopBtn">
      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none"
           stroke="#DC1E50"
           stroke-width="3" stroke-linecap="square" stroke-linejoin="arcs">
        <path d="M18 15l-6-6-6 6"/>
      </svg>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import helpModal from '@/components/application/DigitalApplication/Modals/HelpModal.vue'
  import ownersModal from '@/components/application/DigitalApplication/Modals/OwnersModal.vue'
  import signationModal from '@/components/application/DigitalApplication/Modals/SignationModal.vue'
  import deleteFileModal from '@/components/application/DigitalApplication/Modals/DeleteFileModal.vue'
  import projektabschlussModal from '@/components/application/DigitalApplication/Modals/ProjektabschlussModal.vue'
  import FileIcon from 'vue-material-design-icons/FileOutline.vue'
  import CloseIcon from 'vue-material-design-icons/Close.vue'
  import HelpIcon from 'vue-material-design-icons/HelpCircleOutline.vue'
  import { errorHandler } from '@/helpers/formHelper.js'
  import SignButtonDownload from '@/components/files/SignButton.vue'
  import DigitalApplicationState from '@/components/application/DigitalApplication/DigitalApplicationState.vue'
  import { DxToast, DxPosition } from 'devextreme-vue/toast'
  import DownloadIcon from 'vue-material-design-icons/TrayArrowDown.vue'

  export default {
    data: () => ({
      files: [],
      hasError: false,
      errorMessage: '',
      uploadProblem: false,
      deleteProblem: false,
      hasUnknownError: false,
      application: {
        objekt: {},
        gesuch: {},
        eigentuemer: {},
        kontaktPerson: {},
        gesuchArt: '',
        zusicherung: {}
      },
      showOverlay: true,
      hasNoAccess: false,
      showNotification: false,
      notificationMessage: '',
      historyFiles: false,
      deleteFiles: false,
      fileToDelete: null,
      wrongFormat: false,
      longName: false,
      selectedTab: null,
      showTopBtn: false,
      showUploadOverlay: false,
      isSubmitting: false,
      historyIconRotate: '0',
      showHistory: false,
      maxFileLimit: 20
    }),
    components: {
      helpModal,
      ownersModal,
      signationModal,
      FileIcon,
      CloseIcon,
      HelpIcon,
      SignButtonDownload,
      DigitalApplicationState,
      DxToast,
      DxPosition,
      deleteFileModal,
      projektabschlussModal,
      DownloadIcon
    },
    created () {
      window.addEventListener('scroll', this.scrollListener, true)
      const { applicationId, redirectFromModal } = this.$route.params
      this.getApplicationById(applicationId)
      if (redirectFromModal) {
        this.showNotification = true
        this.notificationMessage = 'Ihr Gesuch ist erstellt und gespeichert. Sie können Dokumente auch später hochladen und signieren.'
      }
      this.getFilesHistory()
    },
    mounted () {
      this.$root.$on('showSignationNotification', () => {
        this.showNotification = true
        this.notificationMessage = 'Signieren erfolgreich'
        this.getFilesHistory()
      })
      this.$root.$on('showRedirectNotification', () => {
        this.showNotification = true
        this.notificationMessage = 'Die Person wurde eingeladen und erhält eine E-Mail mit Link zum Login.'
      })
      this.$root.$on('removeFileFromCloudinary', () => {
        this.deleteFileFromCloudinary()
      })
      this.$root.$on('showProjektabschlussNotification', () => {
        this.showNotification = true
        this.notificationMessage = 'Der Projektabschluss wurde eingereicht.'
        this.getFilesHistory()
      })
    },
    methods: {
      async getApplicationById (applicationId) {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('application/GET_APPLICATION_BY_ID', applicationId).then(res => {
          const { errors, data } = res

          const { userGesucheById } = data

          if (!userGesucheById) {
            this.hasNoAccess = true
            this.showOverlay = false
          }

          if (errors) {
            this.showOverlay = false
            return errorHandler(this, errors)
          }

          this.application = data.userGesucheById
          this.showOverlay = false
        }).catch(err => {
          this.showOverlay = false
          this.hasUnknownError = true
          console.error(err)
        })
      },
      onFileChange (e) {
        var openedFiles = e.target.files || e.dataTransfer.files
        if (!openedFiles.length) return
        this.prepareFilesForUpload(openedFiles)
      },
      addFile (e) {
        const droppedFiles = e.dataTransfer.files
        if (!droppedFiles) return
        this.prepareFilesForUpload(droppedFiles)
        e.target.value = ''
      },
      prepareFilesForUpload (uploadedFiles) {
        ([...uploadedFiles]).forEach(f => {
          if (f.name.length > 60) {
            this.longName = true
            setTimeout(() => {
              this.longName = false
            }, 5000)
            return
          }

          if (f.type === 'application/pdf' || f.type.includes('image/')) {
            var promise = this.getBase64(f)
            const _this = this
            promise.then(function (result) {
              result = result.split(',').pop()
              _this.upload(result, f.name)
            })
          } else {
            this.wrongFormat = true
            setTimeout(() => {
              this.wrongFormat = false
            }, 5000)
          }
        })
      },
      async upload (base64file, filename) {
        this.showUploadOverlay = true
        const formData = {
          gesuchId: this.application.gesuchId,
          gesuchKey: this.application.gesuchKey,
          fileContentBase64: base64file,
          fileName: filename
        }
        try {
          const data = await this.$store.dispatch('cloudinary/UPLOAD_FILE_TO_CLOUDINARY', formData)
          if (data.errors) throw data.errors
          if (data.data.fileUploadCloudinary.cloudinaryResponseType !== 'SUCCESSFUL') {
            this.uploadProblem = true
            setTimeout(() => {
              this.uploadProblem = false
            }, 8000)
          }
          this.showUploadOverlay = false
          this.getFilesHistory()
        } catch (err) {
          this.uploadProblem = true
          this.showUploadOverlay = false
          setTimeout(() => {
            this.uploadProblem = false
          }, 8000)
        }
      },
      async deleteFileFromCloudinary () {
        const formData = {
          gesuchId: this.application.gesuchId,
          gesuchKey: this.application.gesuchKey,
          fileName: this.fileToDelete
        }
        try {
          const data = await this.$store.dispatch('cloudinary/DELETE_FILE_IN_CLOUDINARY', formData)
          if (data.errors) throw data.errors
          if (data.data.fileDeleteInCloudinary.cloudinaryResponseType !== 'SUCCESSFUL') {
            this.deleteProblem = true
            setTimeout(() => {
              this.deleteProblem = false
            }, 8000)
          }
          this.getFilesHistory()
          this.fileToDelete = null
          this.$refs.file.value = null
        } catch (err) {
          this.deleteProblem = true
          setTimeout(() => {
            this.deleteProblem = false
          }, 8000)
        }
      },
      async getFilesHistory () {
        const { applicationId } = this.$route.params
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('cloudinary/GET_FILES_HISTORY', applicationId).then(res => {
          const { errors } = res

          if (errors) {
            this.showOverlay = false
            this.hasError = true
            this.errorMessage = 'Es ist ein Fehler mit den hochgeladenen Dateien aufgetreten. Bitte melden Sie sich bei der Energieagentur St. Gallen.'
          }

          const historyFilesFound = this.fileHistory.find(el => el.deleteAllowed === false)
          const deleteFilesFound = this.fileHistory.find(el => el.deleteAllowed === true)
          this.historyFiles = !!historyFilesFound
          this.deleteFiles = !!deleteFilesFound
        }).catch(err => {
          this.showOverlay = false
          this.hasUnknownError = true
          console.error(err)
        })
      },
      async sendFilesToServer () {
        if (!this.uploadDisabled) {
          this.isSubmitting = true
          try {
            const { errors } = await this.$store.dispatch('cloudinary/SIGN_AND_SEND', this.application.gesuchKey)
            if (errors) throw errors
            this.getFilesHistory()
            this.showNotification = true
            this.notificationMessage = 'Die Beilagen wurden hochgeladen.'
            this.isSubmitting = false
          } catch (err) {
            this.hasUnknownError = true
            this.isSubmitting = false
            setTimeout(() => {
              this.hasUnknownError = true
            }, 5000)
          }
        }
      },
      deleteFileModal (fileName) {
        this.fileToDelete = fileName
        this.$refs.deleteFilesModal.openModal()
      },
      refreshApplication () {
        const { applicationId } = this.$route.params
        this.getApplicationById(applicationId)
      },
      openOwnersModal () {
        this.$refs.ownersModal.openModal()
      },
      openSignationModal () {
        if (!this.uploadDisabled) {
          this.$refs.signationModal.openModal()
        }
      },
      openProjektabschlussModal () {
        if (!this.uploadDisabled) {
          this.$refs.projektabschlussModal.openModal()
        }
      },
      getBase64 (file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => resolve(reader.result)
          reader.onerror = error => reject(error)
        })
      },
      onHideNotification () {
        this.showNotification = false
      },
      scrollListener (ev) {
        if (ev.target.scrollTop > 200) {
          this.showTopBtn = true
        } else {
          this.showTopBtn = false
        }
      },
      topFunction () {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      },
      handleHistory () {
        this.historyIconRotate = this.historyIconRotate === '0' ? '180' : '0'
        this.showHistory = this.historyIconRotate !== '0'
      },
      countItems () {
        const historyFilesArr = this.fileHistory.filter(el => el.deleteAllowed === false)
        return historyFilesArr.length
      },
      getCloudinaryURL (fileId) {
        const currFile = this.fileHistory.find(el => el.fileId === fileId)
        let gesuchKey = ''
        if (this.application.gesuchKey) {
          gesuchKey = this.application.gesuchKey.replace(/\s/g, '')
        }
        const version = Math.random().toString().slice(2, 12) // version number is for caching
        const prepLink = 'https://res.cloudinary.com/' + process.env.VUE_APP_CLOUDINARY_CLOUDNAME + '/image/upload/v' + version + process.env.VUE_APP_CLOUDINARY_PATH + '/' + gesuchKey + '/' + currFile.fileName
        return prepLink
      }
    },
    beforeDestroy () {
      window.removeEventListener('scroll', this.scrollListener, true)
    },
    computed: {
      countCloudinaryFiles () {
        return this.fileHistory.filter(x => x.deleteAllowed).length
      },
      currentUserOwner () {
        if (this.application.eigentuemer.email === this.currentUser.email) {
          return true
        } else {
          return false
        }
      },
      uploadDisabled () {
        return this.deleteFiles === false || this.countCloudinaryFiles > this.maxFileLimit
      },
      dynamicTabName () {
        if ([12, 16].includes(this.application.statusId)) {
          return 'Online einreichen'
        } else {
          return 'Dokumente'
        }
      },
      compareOwnerWithInvitation () {
        const user = this.currentUser
        const compare = this.permissions.filter(function (el) {
          return el.email === user.email &&
            el.inviteState === 'ACCEPTED'
        })
        if (compare.length > 0) {
          return true
        } else {
          return false
        }
      },
      ...mapGetters({
        currentUser: 'user/CURRENT_USER',
        permissions: 'permission/PERMISSIONS_SIGNATURE',
        fileHistory: 'cloudinary/UPLOADEDFILES'
      })
    }
  }
</script>

<style lang="scss" scoped>
 html {
   scroll-behavior: smooth;
 }

.icon-gray {
  background-color: $black-10;
  padding: 3px .5rem .5rem;
  border-radius: 0.5rem;
  margin-right: 0.25rem;
}

.icon-history {
  cursor: pointer;
  margin-left: .5rem;
}

.cursor {
  cursor: pointer;
}

 .detail-building{
    [class*="col-"]{
      margin-top: 40px;
    }
  }
  .detail-user{
    [class*="col-"]{
      margin-top: 20px;
    }
    h5{
      margin-bottom: 5px;
    }
  }

  .detail-table{
    width: 100%;

    tr{
      border-bottom: 1px solid $black-20;

      td:first-child{
        text-align: left;
        padding-right: 10px;
        width: 50%;
      }

      td:last-child{
        text-align: left;
      }
    }
  }
  .logo-wrapper.logo-detail{
    img{
      padding-right: 0;
      width: 50px;

      @include media-breakpoint-down(xl) {
        padding-right: 10px;
      }
    }
  }

  .text-wrapper .red-title {
    color: $magenta;
    font-weight: $font-weight-medium;
    font-size: 1.3821rem;
    margin-top: 1rem;
  }

  .status-badge {
    margin-top: 30px;
  }

  #topBtn {
  position: fixed;
  bottom: 30px;
  right: 40px;
  z-index: 99;
  cursor: pointer;

  svg {
    stroke: $magenta;
  }
}

  #topBtn:hover {
    svg {
      stroke: $green;
    }
  }
</style>

<style lang="scss">
  .application-toast .dx-toast-success {
    background-color: $green;
  }
</style>
